import React, { Component } from 'react'
import {
    Card,
    CardContent,
    CardActions,
    CardMedia,
    Typography,
    Box,
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/pro-duotone-svg-icons/faChevronRight'
import { CompactButton } from '@/shared/ui/buttons'

import logo from '../../../images/xlab-logo.jpg'
import EnvironmentInfo from './EnvironmentDetails'

class EnvironmentCard extends Component {
    getLogo(item) {
        if (!item.logo || !item.logo) {
            return logo
        }

        return item.logo
    }

    addDefaultSrc(ev) {
        ev.target.src = '/static/images/xlab-logo.jpg'
    }

    render() {
        const kedo = this.props.kedo
        return (
            <Card
                data-cy="environment-item"
                data-cy-id={this.props.item.id}
                data-cy-active={this.props.item.active ? 'true' : 'false'}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    boxShadow: '0 0 0 rgba(0,0,0,0.08)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                    },
                    ...(this.props.item.active !== true && {
                        opacity: 0.6,
                    }),
                    width: '260px',
                }}
            >
                <Box
                    sx={{
                        position: 'relative',
                        cursor: this.props.item.active ? 'pointer' : 'default',
                    }}
                    onClick={
                        this.props.item.active ? this.props.environment : null
                    }
                >
                    <CardMedia
                        component="img"
                        onError={this.addDefaultSrc}
                        image={`/images/environment/${this.props.item.id}/logo.png`}
                        alt={`${this.props.item.name}`}
                        sx={{
                            maxHeight: 200,
                            objectFit: 'cover',
                        }}
                    />
                </Box>

                <CardContent
                    sx={{
                        flexGrow: 1,
                        cursor: this.props.item.active ? 'pointer' : 'default',
                        pt: 2.5,
                        pb: 1,
                    }}
                    onClick={
                        this.props.item.active ? this.props.environment : null
                    }
                >
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{
                            fontWeight: 600,
                            fontSize: '1.1rem',
                            mb: 0.5,
                            color: '#1a1a1a',
                        }}
                    >
                        {this.props.item.name}
                    </Typography>
                    {this.props.item.active ? (
                        window.innerWidth > 576 ? (
                            <Typography
                                variant="body2"
                                sx={{
                                    color: '#666',
                                    fontSize: '0.875rem',
                                    lineHeight: 1.5,
                                }}
                            >
                                {this.props.item.description}
                            </Typography>
                        ) : null
                    ) : (
                        <Typography
                            variant="body2"
                            sx={{
                                fontStyle: 'italic',
                                color: '#999',
                            }}
                        >
                            {this.props.kedo.t('Environment is inactive')}
                        </Typography>
                    )}
                </CardContent>

                <CardActions
                    sx={{
                        justifyContent: 'space-between',
                        px: 2,
                        pb: 2,
                        pt: 0,
                    }}
                >
                    <EnvironmentInfo
                        kedo={kedo}
                        environment={this.props.environment}
                        item={this.props.item}
                    />
                    <CompactButton
                        disabled={!this.props.item.active}
                        onClick={this.props.environment}
                        title={kedo.t('Open environment')}
                        sx={{
                            minWidth: 'auto',
                            borderRadius: '8px',
                            px: 2,
                            py: 1,
                            boxShadow: 'none',
                            '&:hover': {
                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                            },
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faChevronRight}
                            style={{ width: '16px' }}
                        />
                    </CompactButton>
                </CardActions>
            </Card>
        )
    }
}

export default EnvironmentCard
